"use client";

import styled from "styled-components";

import Image from "../image";

export const BoxInfo = styled.div`
  diplay: flex;
  flex-direction: column;
`;

export const HeaderBoxInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 25px;
`;

export const ImageComponet = styled(Image)`
  width: 80px;
  height: 80px;
  border-radius: 100px;
  object-fit: cover;
`;

export const EstablishmentName = styled.h2`
  font-family: "Helvetica Neue Medium";
  font-size: 23px;
  color: var(--colorTitle);
  margin-left: 10px;
`;

export const BodyBoxInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const TitleDescription = styled.h3`
  font-family: "Inter Regular";
  font-size: 20px;
  color: var(--labelColor);
  margin-bottom: 0;
`;

export const SubTitle = styled.h4`
  font-size: 18px;
  color: var(--labelColor);
`;

export const Description = styled.p`
  max-width: 400px;
  font-family: "Roboto Regular";
  font-size: 14px;
  color: var(--textLight);
`;

export const ListItems = styled.ul`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Items = styled.li`
  display: flex;
  align-items: center;
  font-family: "Inter Regular";
  font-size: 15px;
  color: var(--textLight);

  svg {
    stroke: var(--textLight);
    width: 23px;
    height: 23px;
    margin-right: 5px;
  }
`;

export const Value = styled.span`
  font-family: "Inter Medium";
  font-size: 25px;
  color: var(--successSystem);
`;
